import { Helpers } from "./helpers/helpers";


export class Modal {
	public modal: HTMLElement;
	private activeEmbedCode: string;
	private triggerSelector: string;
	public onOpen: (e: ModalEvent) => any;
	private onClose: () => any;
	private primaryModal: Modal = null; // this is the reference to the primary-modal object created during initialization
	private static openedModal: Modal = null; // this is the currently open Modal, the Modal can be instantiated throughout the application and this references the Modal object that is open.

		

	constructor(triggerSelector: string = '.modal-trigger', modalSelector='#primary-modal', onOpen: (e: ModalEvent) => any = null, onClose: () => any = null) {
		
		
		this.modal = <HTMLElement>document.querySelector(modalSelector);
		
		this.triggerSelector = triggerSelector;
		this.onOpen = onOpen;
		this.onClose = onClose;
		this.activeEmbedCode = "";		
		this.initiateModal();
		if (this.getModalCloseButton() !== null) {
			this.getModalCloseButton().addEventListener('click', () => this.close());
		}
	}

	private initiateModal() {
		if (this.triggerSelector === "") return;
		let triggers = document.querySelectorAll(this.triggerSelector);
		let self = this;
		triggers.forEach((trigger) => {
			trigger.addEventListener('click', e => {
				e.preventDefault();
				self.open(e);
			});
		});
	}

	public addFadeOutCloseBehavior(selector: string) {
		let btnModalClose = this.findElement(selector);
		if (!Helpers.isNullOrUndefined(btnModalClose)) {
			btnModalClose.addEventListener('click',
				(e) => {
					e.preventDefault();
					this.modal.fadeOut();
				});
		}
	}

	public findElement(selectors: string): HTMLElement {
		return this.modal.querySelector(selectors);
	}

	public findBodyElement(selectors: string): HTMLElement {
		return this.getModalBody().querySelector(selectors);
	}

	public getModal(): HTMLElement {
		return this.modal;
	}

	public getModalCloseButton(): HTMLButtonElement {
		return this.findElement('.close') as HTMLButtonElement;
	}

	public getModalBody(): HTMLElement {
		return this.modal.querySelector('.modal-body');
	}

	public setModalBody(innerHtml: string) {
		this.getModalBody().innerHTML = innerHtml;
	}

	public addBodyClass(className: string) {
		this.getModalBody().classList.add(className);
	}	

	public fadeIn() {
		this.modal.fadeIn();
	}

	public fadeOut() {
		this.modal.fadeOut();
	}


	public open(event:Event) {
		let self = this;
		Modal.openedModal = self;
		this.modal.classList.add('opened');
		self.fadeIn();
		if (self.onOpen !== null) {
			self.onOpen({ clickEvent: event });
		}
	}

	public close(skipCallback: boolean = false) {
		Modal.openedModal = null;
		this.modal.classList.remove('opened');
		this.fadeOut();
		if (this.onClose !== null && !skipCallback) {
			this.onClose();
		}
	}


}

export class ModalEvent {
	clickEvent: Event;
}